// Module
var code = "<div class=\"date-picker-drop-down\" style=\"position:absolute;left:{{.left || 0}}px;top:{{.top || 0}}px;{{^.visible}}visibility:hidden;{{/}}\">\r\n    <terceraDatePickerCalendarComponent name=\"dtpicker\" />\r\n</div>\r\n";
// Exports
export default code;